<a
	class="tw:no-underline! tw:text-secondary! tw:flex tw:gap-2 tw:items-center tw:group tw:text-base tw:font-medium tw:px-1 tw:py-4 tw:border-b tw:border-[#DDDEDD] tw:cursor-pointer"
>
	@if (icon()) {
		<mat-icon>{{ icon() }}</mat-icon>
	}
	<span class="tw:group-hover:text-default tw:[.active_&]:text-default">
		<ng-content></ng-content>
	</span>
</a>
